import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "./api";

const AdminCtx = createContext(null);

export function AdminProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    authApi.get("/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const { data } = await authApi.post("/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await authApi.post("/logout").catch(() => {});
    setUser(null);
  };

  return <AdminCtx.Provider value={{ user, setUser, login, logout }}>{children}</AdminCtx.Provider>;
}

export const useAdmin = () => useContext(AdminCtx);
